import { Component, OnInit, OnDestroy } from "@angular/core";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { AsyncPipe } from "@angular/common";
import { SharedService } from "./services/shared.service";
import { AiProcessingService } from "./services/ai-processing.service";
import { SimpleLoaderComponent } from "./shared/common-components/simple-loader/simple-loader.component";
import { AiProcessingModalComponent } from "./shared/common-components/ai-processing-modal/ai-processing-modal.component";
import { AiFabComponent } from "./shared/common-components/ai-fab/ai-fab.component";
import { ToastComponent } from "./shared/common-components/toast/toast.component";
import { filter, Subscription } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [RouterOutlet, AsyncPipe, SimpleLoaderComponent, AiProcessingModalComponent, AiFabComponent, ToastComponent],
  standalone: true,
})
export class AppComponent implements OnInit, OnDestroy {
  isSpinnerShow: boolean = false;
  private routerSubscription?: Subscription;
  private spinnerSubscription?: Subscription;

  constructor(
    public sharedService: SharedService,
    public aiProcessingService: AiProcessingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.spinnerSubscription = this.sharedService.isSpinnerShow.subscribe((res) => {
      this.isSpinnerShow = res;
    });

    // Scroll to top on route change
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        setTimeout(() => {
          const containerSelectors = [
            '.layout-container',
            '.panel-content',
            '.left-panel',
            '.right-panel',
            '.editor-container',
            '.workspace',
            '.main-layout'
          ];

          containerSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element: any) => {
              if (element && typeof element.scrollTop !== 'undefined') {
                element.scrollTop = 0;
              }
            });
          });
        }, 100);
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.spinnerSubscription?.unsubscribe();
  }
}
